import { formatCurrency } from 'components/Widget/shared/currency';
import { FREQUENCY_MULTIPLIERS, MAX_ANNUAL_SAVINGS, OVERDRAFT_FEE } from './constants';
import type { FrequencyKey } from './types';

/** Fees avoided over a year, capped because a SpotMe limit is individual. */
export const calculateAnnualSavings = (count: number, frequency: FrequencyKey): number =>
  Math.min(OVERDRAFT_FEE * count * FREQUENCY_MULTIPLIERS[frequency], MAX_ANNUAL_SAVINGS);

/** Legacy dropped a `.00` tail but kept real cents, and labelled every total annual whatever the frequency. */
export const formatAnnualSavings = (amount: number): string => `${formatCurrency(amount).replace(/\.00$/, '')} / year*`;
